// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from "./AuthContext"; 
import LandingPage from './LandingPage';
import QRCodeGenerator from './QRCodeGenerator';
import Header from './Header';
import { ThemeProvider } from './ThemeContext';
import PricingPage from './PricingPage';
import QRRedirect from './QRRedirect';
import './App.css';

// Layout component to control header visibility
function AppLayout() {
  const location = useLocation();
  const { user } = useAuth();
  
  // Hide header on /qrgenerate when user is signed in
  const shouldShowHeader = !(location.pathname === '/qrgenerate' && user);

  return (
    <div className="App">
      {shouldShowHeader && <Header />}
      
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path='/qrgenerate' element={<QRCodeGenerator />} />
        <Route path="/pricing-plans" element={<PricingPage />} />
        <Route path="/qr/:shortId" element={<QRRedirect />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppLayout />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;